import React from "react";
import MachineList from "../components/Machines";

export default function Dashboard() {
	return (
		<div className="page dashboard">
			<div className="page-header">
				<h1 className="page-title">Autómatas finitos</h1>
			</div>
			<MachineList />
		</div>
	);
}
